import Grid2 from '@mui/material/Grid2';
import MultiColPointDataTable from '@src/components/_shared/MultiColPointDataTable';
import { Typography } from '@mui/material';
import useGetInternalWidgetConfig from '@src/hooks/api/queries/useGetInternalWidgetConfig';
import { WidgetTypePointList } from '@src/types/Widget';
import Spinner from '@components/_elements/Spinner/Spinner';
import { GridRowId } from '@mui/x-data-grid-pro';
import { usePCSWidget } from './PCSWidgetProvider';
import FormattedAlias from '../Translations/FormattedAlias';

export default function PCSDetail({
  pcsId,
  unitControllerId,
  unitControllerEngineeringId,
}: {
  pcsId: GridRowId;
  pcsName: string;
  unitControllerId: string;
  unitControllerEngineeringId: string;
}) {
  const { widgetId, isUnitScope } = usePCSWidget();

  const {
    data: widgetConfig,
    isLoading,
    isError,
  } = useGetInternalWidgetConfig<WidgetTypePointList>(
    `${widgetId}Detail`,
    {
      sourceDeviceId: pcsId as string,
      ...(isUnitScope
        ? {
            unitControllerId,
            unitControllerEngineeringId,
          }
        : {}),
    },
    {
      queryKeys: [pcsId as string, unitControllerId],
    },
  );

  if (isLoading) {
    return <Spinner type='content-small' />;
  }
  if (isError) {
    return (
      <Typography textAlign='center' marginTop='50px'>
        <FormattedAlias id='Error fetching pcs details.' />
      </Typography>
    );
  }

  return (
    <Grid2 container justifyContent='space-evenly'>
      <MultiColPointDataTable
        dataPointsMatrix={widgetConfig?.dataPoints || []}
      />
    </Grid2>
  );
}
